import { Loadable, OrderExchangeData } from '@eih-netbroker/common';
import { ReactComponent as InfoIcon } from '../../../../../assets/icons/information-line.svg';
import { NbLoader } from '../../../../../shared/components/loader/Loader';
import { NbSwitch } from '../../../../../shared/components/toggle-button/Switch';
import { NbTooltip } from '../../../../../shared/components/tooltip/Tooltip';
import { ConditionsTooltip } from '../conditions-tooltip/ConditionsTooltip';
import classes from './OrderCurrencyExchangeSwitch.module.scss';

type OrderCurrencyExchangeSwitchProps = OrderExchangeData & {
  conditionsSatisfied: boolean;
  readOnly: boolean;
  disabled: boolean;
};

export const OrderCurrencyExchangeSwitch = ({
  conditions,
  isEnabled,
  setEnabled,
  conditionsSatisfied,
  readOnly,
  disabled,
}: OrderCurrencyExchangeSwitchProps) => {
  if (disabled) {
    return (
      <NbSwitch
        disabled
        data-testid="order-currency-exchange-switch"
        color="secondary"
        checked={false}
      />
    );
  }

  if (conditions.isLoading) {
    return (
      <NbLoader
        dataTestId="order-currency-exchange-switch-loader"
        verticalCenter
        className={classes.loader}
        size="default"
      />
    );
  }

  if (Loadable.hasValue(conditions) && conditionsSatisfied) {
    return (
      <NbSwitch
        readOnly={readOnly}
        data-testid="order-currency-exchange-switch"
        color="secondary"
        checked={isEnabled}
        onChange={() => setEnabled(!isEnabled)}
      />
    );
  }

  if (Loadable.hasValue(conditions) && !conditionsSatisfied) {
    if (isEnabled) {
      setEnabled(false);
    }

    return (
      <NbTooltip
        title={<ConditionsTooltip conditions={conditions} />}
        placement="top"
        slotProps={{
          popper: {
            modifiers: [
              {
                name: 'offset',
                options: {
                  // reduce the gap between the tooltip and the icon
                  offset: [0, -10],
                },
              },
            ],
          },
        }}
      >
        <div className={classes.tooltip}>
          <InfoIcon className={classes.infoIcon} />
        </div>
      </NbTooltip>
    );
  }

  return null;
};
